import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  restoreBackupCachedItem<T>(key: string): boolean {
    const currentCachedItem = localStorage.getItem(key);
    const backupCachedItem = localStorage.getItem(`${key}*`);

    if (currentCachedItem && backupCachedItem) {
      localStorage.setItem(key, backupCachedItem);
      localStorage.removeItem(`${key}*`);
      return true;
    } else if (currentCachedItem) {
      localStorage.removeItem(key);
      return false;
    }
  }

  saveItemToCache<T>(key: string, item: T): void {
    localStorage.setItem(key, JSON.stringify(item));
  }

  loadItemFromCacheWithBackup<T>(key: string): T | null {
    const savedItem = localStorage.getItem(key);

    if (savedItem) {
      localStorage.setItem(`${key}*`, savedItem);
      return JSON.parse(savedItem) as T;
    }

    return null;
  }

  removeAllCachedItemsByKey(key: string): void {
    const cachedItem = localStorage.getItem(key);
    const cachedItemBackup = localStorage.getItem(`${key}*`);
    
    if (cachedItem) {
      localStorage.removeItem(key); // clear cached item
    }
    if (cachedItemBackup) {
      localStorage.removeItem(`${key}*`); // clear cached item backup
    }
  }
}
